export default "__VITE_ASSET__DIkNRbB2__"